import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { APP } from 'src/Configs/App'

export interface PublicSpotifyArtist {
  name: string
  photoUrl?: string
  spotifyId: string
  followersCount?: number
}

interface SearchArtistsParams {
  artistName: string
  offset?: number
  limit?: number
}

const NUMBER_OF_RESULTS_PER_PAGE = 20

export const publicSpotifyArtistsApi = createApi({
  reducerPath: 'publicSpotifyArtistsApi',
  tagTypes: ['PublicSpotifyArtist'],
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    searchSpotifyArtists: builder.query<
      PublicSpotifyArtist[],
      SearchArtistsParams
    >({
      query: ({
        artistName,
        offset = 0,
        limit = NUMBER_OF_RESULTS_PER_PAGE,
      }) => ({
        url: `${APP.TIKTOK_SERVER}/public/spotify-artists/search`,
        params: { artistName, offset, limit },
      }),
      providesTags: ['PublicSpotifyArtist'],
    }),
    getSpotifyArtistById: builder.query<PublicSpotifyArtist, string>({
      query: (artistId) => ({
        url: `${APP.TIKTOK_SERVER}/public/spotify-artists/${artistId}`,
      }),
      providesTags: ['PublicSpotifyArtist'],
    }),
  }),
})

export const {
  useLazySearchSpotifyArtistsQuery,
  useLazyGetSpotifyArtistByIdQuery,
} = publicSpotifyArtistsApi
